import React from "react";
import {
    AI_CATEGORIZATION_SCORE_DIGITS,
    AI_CATEGORIZATION_SCORE_FACTOR
} from "../../../../controllers/CategorizationReviewPageFilterController.ts";
import type {DeserializedGridCellParams} from "../../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {PartGridRowModel} from "../CategorizationTableDataModel.ts";

export const ScoreCell: React.FC<DeserializedGridCellParams<PartGridRowModel>> = (props) => {
    const value = props.value;
    if (!value) return <></>
    const s = Number(value) * AI_CATEGORIZATION_SCORE_FACTOR;
    const sScore = s.toFixed(AI_CATEGORIZATION_SCORE_DIGITS);
    // Show the score with 2 digits
    return <span>{sScore}</span>;
}
